<template>
  <HeaderLabels :labels="labels" @update="updateField" />
</template>

<script>
import { textLabel, selectLabel } from '@/reusable/header-labels/labels'
// Libraries
import { mapActions, mapState } from 'vuex'
// Components
import HeaderLabels from '@/reusable/header-labels/HeaderLabels'

export default {
  components: {
    HeaderLabels
  },

  computed: {
    ...mapState('product-show', ['product', 'editingData', 'allSubjectCategories']),

    labels() {
      const { product, editingData } = this
      const { publishers, types, owners } = editingData

      return [
        {
          section: true,
          items: [
            selectLabel(product, 'Publisher', 'publisher.name', 'publisher_id', 'publisher.id', publishers, {
              link: true,
              to: `/publishers/${product.publisher.id}`
            }),

            textLabel(product, 'Alternative name', 'alternative_name'),

            selectLabel(product, 'Managed by', 'owner.name', 'owner_id', 'owner.id', owners)
          ]
        },

        { separator: true },

        {
          section: true,
          items: [
            selectLabel(product, 'Type', 'product_type.name', 'product_type_id', 'product_type.id', types),

            textLabel(product, 'Platform', 'platform'),

            selectLabel(
              product,
              'Subject Category',
              'main_subject_category.name',
              'main_subject_category_id',
              'main_subject_category.id',
              this.allSubjectCategories
            )
          ]
        },

        { separator: true },

        {
          section: true,
          items: [
            textLabel(product, 'ISSN/ISBN', 'print_identifier'),
            textLabel(product, 'eISSN/eISBN', 'online_identifier')
          ]
        }
      ]
    }
  },

  methods: {
    ...mapActions('product-show', ['updateField'])
  }
}
</script>
